"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var react_1 = tslib_1.__importDefault(require("react"));
var Input_1 = tslib_1.__importDefault(require("./Input"));
var theme_1 = require("../../utils/theme");
var openEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbC1ydWxlPSJldmVub2RkIiBvcGFjaXR5PSIuNjM3Ij48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgZD0iTTE1Ljk0NiA5LjIyOEE3LjcyIDcuNzIgMCAwIDAgMi4zNTEgOS4xM2E3LjcxNyA3LjcxNyAwIDAgMCAxMy41OTUuMDk4eiIvPjxwYXRoIHN0cm9rZT0iI2ZmZiIgZD0iTTkuMTUgMTIuMjAyYTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNnoiLz48L3N2Zz4=";
var closedEyeUrl = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PHBhdGggZD0iTTEuODU2IDEwLjc5NGwyLjIxMy0zLjMzTTYuNDE3IDEzbC45MTItMy43NDNtOC44NjcgMS41ODVsLTIuMDYtMy40MjdtLTIuNTcyIDUuNTkzbC0uOTM0LTMuNzZNMS44NTYgNmMyLjAzIDIuMzkzIDQuMzc0IDMuNjQ0IDcuMDMgMy43NTRzNS4wOS0xLjE0MiA3LjMxLTMuNzU0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMS4yNSIgb3BhY2l0eT0iLjY0MiIvPjwvc3ZnPg==";
var Password = (function (_super) {
    tslib_1.__extends(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = react_1.default.createRef();
        _this.state = {
            passwordVisible: false
        };
        _this.refDom = function (dom) {
            _this.inputRef.current = dom;
            var propRef = _this.props.inputRef;
            if (!propRef) {
                return;
            }
            if (typeof propRef === 'function') {
                propRef(dom);
            }
            else {
                propRef.current = dom;
            }
        };
        _this.togglePasswordVisibility = function () {
            var dom = _this.inputRef.current;
            var selectionStart = dom.selectionStart, selectionEnd = dom.selectionEnd;
            _this.setState(function (prevState) { return ({ passwordVisible: !prevState.passwordVisible }); }, function () {
                setTimeout(function () {
                    dom.setSelectionRange(selectionStart, selectionEnd);
                }, 0);
            });
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, showToggle = _a.showToggle, rest = tslib_1.__rest(_a, ["showToggle"]);
            var passwordVisible = _this.state.passwordVisible;
            var iconUrl = passwordVisible ? openEyeUrl : closedEyeUrl;
            return (h(Input_1.default, tslib_1.__assign({ icon: showToggle ? iconUrl : undefined, inputStyle: { letterSpacing: passwordVisible ? '2px' : '4px' }, onClickIcon: _this.togglePasswordVisibility, type: passwordVisible ? 'text' : 'password', inputRef: _this.refDom }, rest)));
        };
        return _this;
    }
    Password.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    return Password;
}(react_1.default.Component));
exports.default = Password;
Password.defaultProps = {
    showToggle: true
};
